import { Grid, Paper, Typography, Torch } from '@prometheus/components';
import { SecondaryContentWrapper } from '@prometheus/features';
import { parseUrlSearchParamsToObject } from '@prometheus/utils';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

export const ErrorPage = () => {
  const { code } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [message, setMessage] = useState('');
  useEffect(() => {
    let m = parseUrlSearchParamsToObject(searchParams)?.message?.[0];
    setMessage(m || 'Oops... something unexpected happened...');
    setSearchParams({}, { replace: true });
  }, []);

  return (
    <Grid container minHeight="100vh">
      <SecondaryContentWrapper>
        <Grid
          container
          minHeight="100%"
          justifyContent="space-around"
          alignContent="center"
        >
          <Grid item xs={12} md={10} lg={8}>
            <Paper
              elevation={0}
              sx={{
                px: 8,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                flexDirection: 'column',
                minHeight: '75vh',
                svg: {
                  position: 'absolute',
                },
                textAlign: 'center',
                my: 'auto',
              }}
            >
              <Torch />
              {message && (
                <>
                  <Typography variant="h2" fontSize={64}>
                    {code}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontSize={40}
                    minHeight={60}
                    mt={2}
                  >
                    {message}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight={400}
                    fontSize={24}
                    mt={4}
                  >
                    Looks like we ran into some issue. Please retry the action.
                    If the issue persists, please contact your system
                    administrator.
                  </Typography>
                </>
              )}
            </Paper>
          </Grid>
        </Grid>
      </SecondaryContentWrapper>
    </Grid>
  );
};
